module.exports = __webpack_public_path__ + "img/add-departure-length-climbing-table-icon.cdfd688a.svg";